$(document).on("turbo:load", () => new window.App.Components.gaTracking())

window.App.Components.gaTracking = class gaTracking {
  constructor() {
    this.debug = true
    this.bindElements()
  }

  bindElements() {
    $(document).on("click", '[data-track-on="click"]', e => {
      const toTrack = $(e.currentTarget)
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-name"),
          toTrack.data("track-category"),
          toTrack.data("track-action"),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    $(document).on("change", '[type="checkbox"][data-track-on="change"]', e => {
      const toTrack = $(e.currentTarget)
      const checked = toTrack.prop("checked") ? "true" : "false"
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-name"),
          toTrack.data("track-category"),
          toTrack.data(`track-action-${checked}`),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    $(document).on("focus", '[data-track-on="focus"]', e => {
      const toTrack = $(e.currentTarget)
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-name"),
          toTrack.data("track-category"),
          toTrack.data("track-action"),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    $(document).on("keyup", '[data-track-on="keyup"]', e => {
      const toTrack = $(e.currentTarget)
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-name"),
          toTrack.data("track-category"),
          toTrack.data("track-action"),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    $(document).on("submit", '[data-track-on="submit"]', e => {
      const toTrack = $(e.currentTarget)
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-name"),
          toTrack.data("track-category"),
          toTrack.data("track-action"),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    // // Trigger track Dig Deeper inner links
    // $(document).on("click", ".more_text a", e => {
    //   const toTrack = $(e.currentTarget)
    //   $(".dig-deeper-link-trigger").data(
    //     "track-action",
    //     "outbound click - " + toTrack.attr("href")
    //   )
    //   return $(".dig-deeper-link-trigger").click()
    // })
  }

  trackNewEvent(name, category, action, label) {
    if (label === undefined) {
      label = ""
    }
    if (this.inDebugMode()) {
      console.log(
        "gtag('event', '" +
          name +
          "', {'" +
          category +
          "', '" +
          action +
          "', '" +
          label +
          "'})"
      )
    }

    return gtag('event', name, {
      'category': category,
      'action': action,
      'label': label
    });
  }

  // Convenience method
  inDebugMode() {
    return this.debug === true
  }
}
